var exports = {
  "UX": "PlutoniumUpsell.module__upsell___LUVEeG",
  "Kk": "PlutoniumUpsell.module__icon___LUVEeG",
  "Qs": "PlutoniumUpsell.module__content___LUVEeG",
  "Qq": "PlutoniumUpsell.module__text___LUVEeG",
  "o1": "PlutoniumUpsell.module__actions___LUVEeG",
  "R3": "PlutoniumUpsell.module__dismissLink___LUVEeG",
};

module.exports = exports;
